import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, Briefcase, Presentation, MonitorSmartphone, CalendarClock, LayoutGrid } from "lucide-react";
import api from "@/lib/api";

function iconFor(name = "", slug = "") {
  const s = `${name} ${slug}`.toLowerCase();
  if (/meeting|conference|board|hall/.test(s)) return Presentation;
  if (/virtual/.test(s)) return MonitorSmartphone;
  if (/flexi|day|desk|pass/.test(s)) return CalendarClock;
  if (/office|private/.test(s)) return Briefcase;
  if (/cowork|shared|space/.test(s)) return Building2;
  return LayoutGrid;
}

export default function SeoLinkHub() {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    api.get("/public/landing-hub").then((r) => setGroups(r.data?.groups || [])).catch(() => setGroups([]));
  }, []);

  if (!groups.length) return null;

  return (
    <section className="bg-slate-50 border-t border-slate-200" data-testid="seo-link-hub">
      <div className="container-cz py-10">
        <h2 className="text-[11px] font-bold tracking-[0.14em] uppercase text-slate-400 mb-5">Explore workspaces across India</h2>
        <div className="divide-y divide-slate-200/70">
          {groups.map((g) => {
            const Icon = iconFor(g.name, g.slug);
            return (
              <div key={g.slug} className="flex flex-col sm:flex-row sm:items-start gap-2.5 sm:gap-6 py-4" data-testid={`seo-hub-group-${g.slug}`}>
                <div className="flex items-center gap-2.5 sm:w-56 lg:w-64 shrink-0">
                  <span className="w-9 h-9 rounded-lg bg-white border border-slate-200 text-primary flex items-center justify-center shrink-0">
                    <Icon className="w-4 h-4" />
                  </span>
                  <span className="font-bold text-primary text-[15px]">{g.name}</span>
                </div>
                <div className="flex flex-wrap items-center text-sm text-slate-500 leading-relaxed">
                  {g.items.map((it, i) => (
                    <span key={it.url} className="flex items-center">
                      <Link to={it.url} className="hover:text-primary transition-colors" data-testid={`seo-hub-link-${g.slug}-${i}`}>{it.label}</Link>
                      {i < g.items.length - 1 && <span className="px-2.5 text-slate-300" aria-hidden="true">|</span>}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
